export default {
  heading: 'Members save four ways',
  subheading: 'REI Co-op Members get 4 offers for 4x the adventure!',
  coupons: [
    {
      image: {
        alt: 'REI Co-op Member Angela R. laughing and pitching a tent at a campground.',
        src: 'https://www.rei.com/dam/20740588_rodriguez20241122_007_membership-coupon',
        rights: 'by Angela R., REI Co-op Member',
      },
      couponImage: {
        alt: '20% off one full-price item coupon',
        src: 'https://www.rei.com/dam/21560568_full-price-coupon.svg',
      },
      heading: '20% off one full-price item',
      body: 'Members save 20% on one full-price item March 14–24. Use coupon code <strong>MEMBER2025</strong> at checkout. Terms & exclusions apply.',
      cta: {
        text: 'Shop coupon-eligible items',
        target: 'https://www.rei.com/s/full-price-coupon-eligible-items',
      },
      key: '0',
    }, {
      image: {
        alt: 'A photo by REI Co-op Member Yvonne L. of the vista during a fall hike through hilly shrubland.',
        src: 'https://www.rei.com/dam/20739626_leow20241216_001_web_lg.jpeg',
        rights: 'by Yvonne L., REI Co-op Member',
      },
      couponImage: {
        alt: '20% off one REI Outlet item coupon',
        src: 'https://www.rei.com/dam/21560571_outlet-coupon.svg',
      },
      heading: '20% off one REI Outlet item',
      body: 'Members save 20% on one REI Outlet item March 14–24. Use coupon code <strong>MEMBER2025</strong> at checkout. Terms & exclusions apply.',
      cta: {
        text: 'Shop REI Outlet',
        target: 'https://www.rei.com/s/outlet-coupon-eligible-items',
      },
      key: '1',
    }, {
      image: {
        alt: 'A photo by REI Co-op Member Dj B-H. of friends (and dog!) soaking up the sun at a lakeside beach.',
        src: 'https://www.rei.com/dam/20553059_dj-bautista-harris_2_membership-coupon',
        rights: 'by Dj B.-H., REI Co-op Member',
      },
      couponImage: {
        alt: '20% off one REi ReSupply used gear item coupon',
        src: 'https://www.rei.com/dam/21560567_resupply-coupon.svg',
      },
      heading: '20% off one Re/Supply used item',
      body: 'Members save 20% off one Re/Supply item March 14–24. Use coupon code <strong>USED2025</strong> at checkout. Offer valid in-store and online at REI.com/used. While supplies last. Terms & conditions apply.',
      cta: {
        text: 'Shop Re/Supply',
        target: 'https://www.rei.com/used',
      },
      key: '2',
    }, {
      image: {
        alt: 'A photo by REI Co-op Member Jill G. of a happy mountain biker navigating a shrubby desert trail.',
        src: 'https://www.rei.com/dam/20547280_jill-gann_web_membership-coupon',
        rights: 'by Jill G., REI Co-op Member',
      },
      couponImage: {
        alt: '20% off one Premium Shop Service Package coupon',
        src: 'https://www.rei.com/dam/21560573_service-coupon.svg',
      },
      heading: '20% off one Premium Service Package',
      body: 'In addition to member pricing, members save 20% on one Premium Service Package (bike or snow) at any REI Co-op Shop location March 14–24. Terms & conditions apply.',
      cta: {
        text: 'Find a bike shop near you',
        target: 'https://www.rei.com/stores/bike-shop',
      },
      key: '3',
    },
  ],
};
